import type { FC } from 'react';
import { Link } from '@george-labs.com/design-system';

import type { Transaction } from '@shared/transactions-types';
import { TransactionType } from '@shared/transactions-types';
import { createUnsafeLinkPath, wrapUrlWithReturnUrl } from '@luna/router';
import { t } from '@luna/i18n';

import { isType } from '../../predicates/isType';

interface Props {
    transaction: Transaction;
    onClick?(): void;
}

export const PaymentOrderLink: FC<Props> = ({ transaction, onClick }) => {
    if (!transaction.paymentOrderUrl) {
        return null;
    }

    if (!isType(TransactionType.BULK)(transaction)) {
        return null;
    }

    const urlWithReturn = wrapUrlWithReturnUrl(transaction.paymentOrderUrl);
    const href = createUnsafeLinkPath(urlWithReturn);

    return (
        <Link data-cy="transaction-payment-order-link" onClick={onClick} href={href}>
            {t('transaction.viewOrderDetail')}
        </Link>
    );
};
